import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { validateEmail } from "../../utils/util";
import { searchUsers } from "../../services/users";
import { Login } from "../../actions/actions";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from '../../components/DropdownMenu'
import { fetchPartners, insertPartner } from "../../services/partners";
import EditButton from '../../svgs/EditButton';
import SearchSvg from '../../svgs/SearchSvg';
const limit = 999
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)


    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type') || '全部'
    //
    const handleSearchName = (e) => { setSearchParams({ page: 1, name: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        const filter = {}
        if (filterType !== '全部') filter['status'] = filterType === '草稿' ? 'draft' : 'published'

        if (filterName) filter['name'] = { "$regex": filterName, "$options": 'i' }
        const res = await fetchPartners(filter, { limit, skip: limit * (page - 1), sort: { order: -1 } })
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }

    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    //new partner
    const [isAdding, setisAdding] = useState(false)
    const handleAddNewPartner = async () => {
        if (!isAdding.name) return alert('請輸入合作夥伴名稱')
        setIsloading(true)
        const res = await insertPartner(props.token?.token, {
            name: isAdding.name,
            thumbnail: '',
            status: 'draft',
            order: 99,
            isNew: true,
            category: [],
            content: [],
            termsAndConditions: [],
            contentTitle: '',
            hero: '',
            promotions: [],
            coupons: [],
            isTshopMostFavourited: false,
            isTshopRecommended: false,
            isTshopTopViews: false,
            isTshopWeeklyPopular: false,
            heros: [],
            hero2: '',
            tags: [],
            logo1: null,
            logo2: null
        })
        if (res.errno) return alert('新增失敗')
        setIsloading(false)
        setisAdding(false)
        alert('新增成功')
        fetchData()
    }

    return (
        <div className="h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden" style={{ overflowY: 'scroll' }}>
            <div className="w-full flex flex-row gap-[16px] items-center px-[16px] py-[24px] relative">
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchName} placeholder="搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="z-[2] flex flex-row gap-[16px]">
                    <div className="text-[#6E604C]">Filter By </div>
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部', '草稿', '已公開']} />
                </div>
                <div className="flex flex-row flex-1 justify-end gap-[16px] z-[2]">
                    <div className="cursor-pointer hover:opacity-[.5]" onClick={() => { setisAdding({}) }}>
                        <AddNewPartnerButton />
                    </div>
                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>

            {/* <div className="w-full flex flex-row gap-[16px] mt-[16px] border-[1px] border-[white] p-[16px] rounded-[8px] bg-[#ffffff90]">
                <div className="font-[700] text-[20px]">
                    合作夥伴管理
                </div>
            </div> */}

            <div className="flex flex-row flex-wrap gap-[16px] mt-[16px] w-full justify-start px-[16px]">
                {['全部', '草稿', '已公開'].map((item, index) =>
                    <div key={index} onClick={() => selectFilter(item)} className="cursor-pointer text-[18px] px-[16px] py-[4px]  hover:opacity-80 items-center flex flex-row" style={{ color: filterType === item ? '#0F737E' : '#00000099', fontWeight: filterType === item ? '700' : '400', borderBottom: filterType === item ? '2px solid #0F737E' : 'none' }}>
                        {item}
                    </div>
                )
                }

            </div>

            <div className="flex flex-row w-full gap-[16px] mt-[16px] flex-wrap p-[16px]">
                {data.map((item, index) => {
                    return (
                        <div key={index} className="w-[400px] relative border-[1px] border-[white] gap-[6px] rounded-[24px] flex justify-start items-center flex-col bg-[#ffffff40]" style={{height:undefined,aspectRatio:1,overflow:'hidden'}}>
                            <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)'}}/>
                            {item?.thumbnail?
                                <img src={item?.thumbnail} className="rounded-[16px] z-[2]" style={{width:'100%',objectFit:'cover'}}/>
                                :<div/>
                            }
                            <div className="text-[20px] font-[700] mt-[24px] z-[2]">{item?.name}</div>
                            <div onClick={navigateTo(`/cms/partners/${item._id}`)} className="cursor-pointer hover:opacity-80 mt-[24px] z-[2]">
                                <EditButton/>
                            </div>
                            
                        </div>
                    )
                })}
            </div>

            {isAdding &&
                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-[#00000080] z-[9999]">
                    <div className="relative w-[480px] bg-white rounded-[16px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[20px] font-[700]">新增合作夥伴</div>
                        <div className="flex flex-row gap-[16px] mt-[64px] w-full">合作夥伴名稱</div>
                        <input onChange={(e) => { setisAdding({ ...isAdding, name: e.target.value }) }} placeholder="請輸入合作夥伴名稱" className="p-[4px] rounded-[4px] w-full border-[1px] border-[black]" />
                        {/* <div onClick={() => { setisAdding(false) }} className="absolute top-[16px] right-[16px] cursor-pointer text-[black] text-[12px] font-[700] p-[4px] hover:opacity-80 items-center flex flex-row" >
                            X
                        </div> */}
                        <div onClick={handleAddNewPartner} className="mt-[64px] cursor-pointer rounded-[99px] py-[8px] text-[white] text-[16px] font-[700] px-[24px] bg-[#0F737E] hover:opacity-80 items-center justify-center flex flex-row mt-[16px] w-full">
                            確認
                        </div>
                        <div onClick={() => { setisAdding(false) }}  className="mt-[8px] cursor-pointer rounded-[99px] py-[8px] text-[#0F737E] text-[16px] font-[700] px-[24px] hover:opacity-80 items-center justify-center flex flex-row mt-[16px] w-full">
                            取消
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)



const AddNewPartnerButton = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={186}
        height={40}
        fill="none"
        {...props}
    >
        <rect width={186} height={40} fill="url(#asdsd)" rx={7} />
        <g clipPath="url(#bsdsd)">
            <path
                fill="#fff"
                d="M45.25 20.75h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z"
            />
        </g>
        <path
            fill="#fff"
            d="m57.208 21.392 1.536.528c-.117.48-.267.965-.448 1.456-.181.48-.4.939-.656 1.376-.256.427-.56.81-.912 1.152l-1.408-1.12c.32-.267.597-.581.832-.944.245-.363.453-.752.624-1.168.181-.427.325-.853.432-1.28Zm3.808.864 1.408-.544c.277.533.523 1.11.736 1.728.213.619.363 1.157.448 1.616l-1.52.592a6.331 6.331 0 0 0-.208-1.056 14.175 14.175 0 0 0-.384-1.2c-.15-.416-.31-.795-.48-1.136Zm2-.336 1.488-.736c.32.395.624.827.912 1.296.288.47.544.933.768 1.392.235.448.41.859.528 1.232l-1.6.848a7.096 7.096 0 0 0-.48-1.264c-.213-.47-.464-.944-.752-1.424a13.26 13.26 0 0 0-.864-1.344ZM63 17.04c.245.437.555.859.928 1.264.384.405.816.768 1.296 1.088.48.32.987.576 1.52.768a8.816 8.816 0 0 0-.448.448c-.16.181-.315.368-.464.56a7.527 7.527 0 0 0-.352.528 7.948 7.948 0 0 1-1.664-1.024 9.762 9.762 0 0 1-1.392-1.424 11.082 11.082 0 0 1-1.056-1.68L63 17.04Zm-3.376-2.544 1.936.288c-.416 1.728-1.067 3.179-1.952 4.352-.885 1.163-2.032 2.085-3.44 2.768a4.622 4.622 0 0 0-.336-.48 6.223 6.223 0 0 0-.48-.576 3.775 3.775 0 0 0-.448-.464c1.301-.533 2.341-1.285 3.12-2.256.779-.981 1.312-2.192 1.6-3.632Zm4.64-2 1.44 1.52c-.64.181-1.339.336-2.096.464-.747.128-1.525.24-2.336.336-.8.085-1.605.15-2.416.192-.81.043-1.6.075-2.368.096a4.708 4.708 0 0 0-.208-.832 6.337 6.337 0 0 0-.288-.816 55.99 55.99 0 0 0 2.256-.112 67.47 67.47 0 0 0 2.24-.192c.736-.075 1.43-.165 2.08-.272.65-.107 1.216-.235 1.696-.384Zm-8.72 3.712H66.28v1.728H55.544v-1.728Zm3.648 3.6h1.76v5.712c0 .416-.043.747-.128.992-.085.256-.267.459-.544.608a2.755 2.755 0 0 1-.96.24c-.363.032-.8.048-1.312.048a5.36 5.36 0 0 0-.192-.864 7.145 7.145 0 0 0-.288-.848c.299.01.587.016.864.016h.544c.17 0 .256-.075.256-.224v-5.68Zm-6.992-5.92 1.072-1.392c.31.128.63.283.96.464.341.17.661.352.96.544.31.192.555.379.736.56L54.776 15.6c-.17-.192-.4-.39-.688-.592-.288-.203-.597-.4-.928-.592-.33-.203-.65-.379-.96-.528Zm-.752 4.352 1.056-1.424c.31.117.63.261.96.432.341.16.661.33.96.512.31.181.56.357.752.528L54.04 19.84a4.268 4.268 0 0 0-.704-.544 8.86 8.86 0 0 0-.944-.576 8.78 8.78 0 0 0-.944-.48Zm.32 7.968c.224-.416.464-.901.72-1.456a34.54 34.54 0 0 0 .784-1.76c.267-.63.517-1.253.752-1.872l1.536 1.072a60.775 60.775 0 0 1-.656 1.712 62.393 62.393 0 0 1-1.392 3.36l-1.744-1.056Zm25.04-2.064h4.096v1.84h-4.096v-1.84ZM67.8 15.28h5.856v1.872H67.8V15.28Zm8.144-1.04h5.824v12.752h-1.92V16.096h-2.064v11.008h-1.84V14.24Zm-2.752 1.04h1.856v.544c0 .139-.005.25-.016.336-.032 1.707-.07 3.163-.112 4.368a71.855 71.855 0 0 1-.128 2.944c-.043.768-.107 1.37-.192 1.808-.085.437-.192.747-.32.928-.181.267-.368.459-.56.576a2.1 2.1 0 0 1-.688.256c-.235.053-.523.08-.864.08-.341.01-.699.005-1.072-.016a4.73 4.73 0 0 0-.16-.976 3.637 3.637 0 0 0-.384-.944c.32.021.613.037.88.048.267.01.475.016.624.016a.672.672 0 0 0 .304-.064.643.643 0 0 0 .24-.24c.085-.117.16-.363.224-.736s.117-.917.16-1.632c.043-.715.08-1.632.112-2.752.032-1.13.064-2.507.096-4.128v-.416Zm-3.488-2.64h1.888c0 1.579-.027 3.088-.08 4.528a38.641 38.641 0 0 1-.32 4.032 16.06 16.06 0 0 1-.848 3.472 8.835 8.835 0 0 1-1.616 2.768 3.546 3.546 0 0 0-.384-.512 5.807 5.807 0 0 0-.512-.512 3.546 3.546 0 0 0-.512-.384c.501-.565.901-1.2 1.2-1.904.31-.715.544-1.493.704-2.336.17-.843.288-1.744.352-2.704.064-.97.101-1.995.112-3.072.01-1.088.016-2.213.016-3.376Zm17.312 4.928h8.016v1.696h-8.016v-1.696Zm-.208 7.6h8.272v1.696h-8.272v-1.696Zm-.848-4.304h10.208v6.592h-1.984v-4.912h-6.336v4.912H85.96v-6.592Zm4.992-6.56a13.17 13.17 0 0 1-1.664 1.92 19.594 19.594 0 0 1-2.224 1.872 22.536 22.536 0 0 1-2.528 1.616 5.859 5.859 0 0 0-.336-.512 5.237 5.237 0 0 0-.432-.56 3.29 3.29 0 0 0-.448-.48 16.4 16.4 0 0 0 2.656-1.648 17.736 17.736 0 0 0 2.288-2.032c.672-.715 1.205-1.397 1.6-2.048h2c.427.608.907 1.19 1.44 1.744a19.156 19.156 0 0 0 1.68 1.552c.597.48 1.216.907 1.856 1.28.64.373 1.275.688 1.904.944a6.712 6.712 0 0 0-.672.832c-.213.299-.405.597-.576.896a20.372 20.372 0 0 1-1.872-1.104 28.737 28.737 0 0 1-1.824-1.344c-.576-.48-1.11-.965-1.6-1.456-.49-.501-.907-.992-1.248-1.472Zm15.936.72h7.664v1.824h-8.576l.912-1.824Zm2.096 3.504h5.168v1.76h-5.168v-1.76Zm-.016 3.552h5.392v1.792h-5.392V22.08Zm-.96-6.448h1.984v11.792h-1.984V15.632Zm-.752-3.072 1.84.48a25.313 25.313 0 0 1-1.056 2.576 21.438 21.438 0 0 1-1.296 2.4 16.474 16.474 0 0 1-1.44 1.952 3.71 3.71 0 0 0-.416-.448c-.181-.17-.368-.336-.56-.496a3.538 3.538 0 0 0-.496-.4c.48-.48.928-1.045 1.344-1.696.427-.65.816-1.35 1.168-2.096.363-.757.667-1.515.912-2.272Zm-4.24-.096 1.856.592a26.537 26.537 0 0 1-2.752 5.344c-.555.81-1.125 1.52-1.712 2.128a8.673 8.673 0 0 0-.288-.624 17.184 17.184 0 0 0-.384-.784 5.034 5.034 0 0 0-.384-.64c.49-.49.96-1.056 1.408-1.696.459-.64.88-1.328 1.264-2.064a15.59 15.59 0 0 0 .992-2.256Zm-1.616 4.432 1.936-1.936v12.448H101.4V16.896Zm14.32 3.552h7.328v1.68h-7.328v-1.68Zm2.688.848 1.28.64a17.513 17.513 0 0 1-.976 1.856c-.373.63-.784 1.227-1.232 1.792a8.575 8.575 0 0 1-1.392 1.392 8.118 8.118 0 0 0-.384-.976 14.019 14.019 0 0 0-.464-.912 7.957 7.957 0 0 0 1.232-1.072c.405-.427.779-.875 1.12-1.344.341-.48.613-.939.816-1.376Zm1.728.816c.16.085.389.235.688.448.299.203.613.427.944.672.341.235.651.459.928.672.277.213.475.368.592.464l-1.12 1.568a9.964 9.964 0 0 0-.624-.704 50.149 50.149 0 0 0-.784-.832c-.277-.288-.549-.56-.816-.816a16.846 16.846 0 0 0-.688-.656l.88-.816Zm5.472-9.696 1.76.304a11.846 11.846 0 0 1-1.552 2.384c-.619.747-1.397 1.435-2.336 2.064a4.524 4.524 0 0 0-.56-.656 3.71 3.71 0 0 0-.656-.544c.832-.49 1.525-1.05 2.08-1.68.555-.64.976-1.264 1.264-1.872Zm.288 1.104h2.896v1.472h-3.92l1.024-1.472Zm2.432 0h.336l.336-.064 1.184.464c-.32 1.195-.789 2.219-1.408 3.072a8.897 8.897 0 0 1-2.192 2.144 12.008 12.008 0 0 1-2.8 1.376 5.302 5.302 0 0 0-.448-.688 4.407 4.407 0 0 0-.544-.64 8.724 8.724 0 0 0 2.432-1.12 7.795 7.795 0 0 0 1.92-1.824 6.977 6.977 0 0 0 1.184-2.432v-.288Zm-4.256 2.624 1.28-.944c.235.15.475.32.72.512.256.192.496.384.72.576.224.192.405.373.544.544l-1.344 1.024a3.92 3.92 0 0 0-.512-.544 13.26 13.26 0 0 0-.688-.608 7.716 7.716 0 0 0-.72-.56Zm2.08 2.672 1.792.32a11.072 11.072 0 0 1-1.744 2.448c-.704.757-1.6 1.44-2.688 2.048a2.273 2.273 0 0 0-.32-.464 5.687 5.687 0 0 0-.416-.464 2.317 2.317 0 0 0-.4-.352c.64-.33 1.205-.688 1.696-1.072.491-.395.907-.8 1.248-1.216.352-.427.629-.843.832-1.248Zm-.176 1.28h3.184v1.552h-4.304l1.12-1.552Zm2.736 0h.368l.336-.048 1.184.416c-.341 1.333-.853 2.459-1.536 3.376a8.715 8.715 0 0 1-2.464 2.256 12.61 12.61 0 0 1-3.232 1.376 5.654 5.654 0 0 0-.432-.816 3.658 3.658 0 0 0-.544-.736c.789-.181 1.52-.427 2.192-.736a8.298 8.298 0 0 0 1.84-1.168 6.791 6.791 0 0 0 2.288-3.632v-.288Zm-4.576 2.816 1.328-.992c.235.16.48.352.736.576.267.213.517.427.752.64.235.203.421.4.56.592l-1.392 1.088a4.216 4.216 0 0 0-.528-.624 14.808 14.808 0 0 0-.72-.672 9.23 9.23 0 0 0-.736-.608Zm-6.432-5.936v.96h3.584v-.96h-3.584Zm0-2.4v.96h3.584v-.96h-3.584Zm-1.568-1.52h6.784v6.416h-6.784v-6.416Zm2.56.704h1.488v4.848h.16v8.816h-1.792v-8.816h.144V13.76Zm21.616-1.136h1.936V27.44h-1.936V12.624Zm-3.568 4.848h9.152v1.776h-9.152v-1.776Zm-.656 3.92h10.464v1.776h-10.464v-1.776Zm.592-7.584 1.616-.608c.192.352.373.73.544 1.136.181.395.341.784.48 1.168.149.384.251.73.304 1.04l-1.728.688a7.94 7.94 0 0 0-.272-1.04c-.117-.395-.261-.8-.432-1.216-.16-.416-.331-.805-.512-1.168Zm7.568-.72 1.968.672a40.04 40.04 0 0 1-.576 1.232c-.203.405-.405.795-.608 1.168-.192.373-.373.71-.544 1.008l-1.568-.624c.16-.31.32-.667.48-1.072.171-.405.331-.816.48-1.232.16-.416.283-.8.368-1.152Zm-9.168-.64 1.776.576a24.307 24.307 0 0 1-1.296 2.72 25.922 25.922 0 0 1-1.6 2.56c-.565.8-1.152 1.504-1.76 2.112a5.532 5.532 0 0 0-.256-.608 16.135 16.135 0 0 0-.384-.752 5.967 5.967 0 0 0-.368-.608 13.86 13.86 0 0 0 1.488-1.696 16.27 16.27 0 0 0 1.344-2.064c.405-.736.757-1.483 1.056-2.24Zm-1.552 4.416 1.824-1.824v12.352h-1.824V16.864Z"
        />
        <defs>
            <linearGradient
                id="asdsd"
                x1={93}
                x2={93}
                y1={0}
                y2={40}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
            </linearGradient>
            <clipPath id="bsdsd">
                <path fill="#fff" d="M31 11h18v18H31z" />
            </clipPath>
        </defs>
    </svg>
)
